import React from 'react'

function PaginateBtns({
    skip, setSkip, limit, setLimit, totalCount
}) {
  return (

   <div className='w-full flex mt-10 justify-between px-4'>
            {
              skip > 0 && totalCount > 0 ?
            
            <div className='w-max flex justify-center min-w-[100px] my-4 bg-tan hover:bg-tanDark border-tan text-ivory border p-2 rounded-lg shadow-sm cursor-pointer' onClick={()=>{
              window.scrollTo(0, 0);
              setSkip((prev) => {
                let newSkip = prev - limit;
                if(newSkip < 0)
                {
                  newSkip = 0;
                }
                return newSkip;
              });
            }}>
             &lt;- Previous
              </div>
              :
              <div></div>
            }
            {              
            totalCount > (skip + limit) &&
              <div className='w-max min-w-[100px] justify-center flex my-4  bg-tan hover:bg-tanDark border-tan text-ivory border p-2 rounded-lg shadow-sm cursor-pointer' onClick={()=>{
              window.scrollTo(0, 0);
                setSkip((prev) => {
                  let newSkip = prev + limit;
                  if(newSkip > totalCount)
                  {
                    newSkip = prev;
                  }
                  return newSkip;
                });
              }}>
                Next -&gt;
              </div>
            }
                      </div>
  )
}

export default PaginateBtns
